import React from "react";
import { StatusChip } from "../../../../../component/listing";

/**
 * The review row, described once.
 *
 * A review is rendered in three places — the cycle's participant list, "My
 * reviews" and "To review" — and each had grown its own copy of the status
 * tones, the status labels and the "3 / 5" rating. They drifted the way copies
 * do, so the same status could read `self_completed` on one screen and
 * "Self done" on the next. The columns live here instead, and the screens
 * assemble the ones they need.
 */
/**
 * `pending` is neutral, not amber. A review nobody has opened yet is where every
 * review starts — it is a waiting state, not a warning, and the dashboard
 * already renders the same status as a neutral "Waiting" pill. Amber here made
 * the same fact read as two different things on two screens.
 */
export const REVIEW_TONE = { pending: "muted", self_completed: "info", manager_completed: "info", finalized: "success" };
export const REVIEW_LABEL = { pending: "Pending", self_completed: "Self done", manager_completed: "Manager done", finalized: "Finalized" };

export const reviewStatusColumn = {
  key: "status",
  label: "Status",
  render: (r) => <StatusChip label={REVIEW_LABEL[r.status]} tone={REVIEW_TONE[r.status]} />,
};

/**
 * The scale lives on the cycle, and which cycle that is depends on the screen:
 * a cycle's own page already has it, a cross-cycle list has to read it off each
 * row. So the caller says where to find the maximum.
 */
export const reviewRatingColumn = (maxOf = (r) => r?.cycle?.ratingScale?.max || 5) => ({
  key: "rating",
  label: "Rating",
  render: (r) => (r.overallRating != null ? `${r.overallRating} / ${maxOf(r)}` : "—"),
});
